import React from "react";
import PropTypes from "prop-types";
import StofComponent from "../shared/StofComponent";
import IconButton from "../common/IconButton";
import Row from "../common/Row";
import { faTimes } from '@fortawesome/free-solid-svg-icons';


import moment from 'moment';

const GeneesmiddelComponent = (props) => {
    const {
        model,
        onCancel
    } = props;

    const stoffenDetails = model.stoffen ?
        model.stoffen.map((s) => {
            return (
                <StofComponent key={s.id} model={s} />
            );
        })
        :
        null;

    return (
        model ?
            <div>
                {onCancel ?
                    <Row>
                        <p className="l-grid__col:11/12">&nbsp;</p>
                        <p className="l-grid__col:1/12">
                            <IconButton
                                icon={faTimes}
                                onClick={onCancel}
                                className="rightUpperCorner"
                            />
                        </p>
                    </Row>
                    :
                    null
                }
                <h2 className="leftMargin">{model.naam}</h2>
                <p className="leftMarginLight">Laatst bijgewerkt op {moment(model.lastUpdatedOn).lang('nl').format('D MMMM YYYY')}</p>
                <p className="leftMargin">{model.stofNamen ? '(' + model.stofNamen + ')' : null}</p>
                <p className="leftMargin">{model.datumUitHandel ? 'Dit geneesmiddel werd uit de handel genomen in ' + model.datumUitHandel : null}</p>
                <br />
                <hr className="line" />
                {stoffenDetails}
            </div>
            :
            null
    );
};

GeneesmiddelComponent.defaultProps = {

};

GeneesmiddelComponent.propTypes = {
    model: PropTypes.object,
    onCancel: PropTypes.func
};

export default GeneesmiddelComponent;